/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type DeploymentSummary = {
  /**
   * The creation date of the deployment.
   */
  createdAt: Date;
  /**
   * The number of external MCP server assets.
   */
  externalMcpAssetCount: number;
  /**
   * The number of tools in the deployment generated from external MCP servers.
   */
  externalMcpToolCount: number;
  /**
   * The number of Functions assets.
   */
  functionsAssetCount: number;
  /**
   * The number of tools in the deployment generated from Functions.
   */
  functionsToolCount: number;
  /**
   * The ID to of the deployment.
   */
  id: string;
  /**
   * The number of upstream OpenAPI assets.
   */
  openapiv3AssetCount: number;
  /**
   * The number of tools in the deployment generated from OpenAPI documents.
   */
  openapiv3ToolCount: number;
  /**
   * The status of the deployment.
   */
  status: string;
  /**
   * The ID of the user that created the deployment.
   */
  userId: string;
};

/** @internal */
export const DeploymentSummary$inboundSchema: z.ZodMiniType<
  DeploymentSummary,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    external_mcp_asset_count: z.int(),
    external_mcp_tool_count: z.int(),
    functions_asset_count: z.int(),
    functions_tool_count: z.int(),
    id: z.string(),
    openapiv3_asset_count: z.int(),
    openapiv3_tool_count: z.int(),
    status: z.string(),
    user_id: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "external_mcp_asset_count": "externalMcpAssetCount",
      "external_mcp_tool_count": "externalMcpToolCount",
      "functions_asset_count": "functionsAssetCount",
      "functions_tool_count": "functionsToolCount",
      "openapiv3_asset_count": "openapiv3AssetCount",
      "openapiv3_tool_count": "openapiv3ToolCount",
      "user_id": "userId",
    });
  }),
);

export function deploymentSummaryFromJSON(
  jsonString: string,
): SafeParseResult<DeploymentSummary, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => DeploymentSummary$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeploymentSummary' from JSON`,
  );
}
